import { useEffect, useRef, useState } from 'react';

interface UseLazyThumbnailReturn {
  ref: React.RefObject<HTMLDivElement>;
  isVisible: boolean;
}

export const useLazyThumbnail = (): UseLazyThumbnailReturn => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '50px 0px', // Start loading images 50px before they enter the viewport
        threshold: 0.01,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return { ref, isVisible };
};
